module.exports = __webpack_public_path__ + "static/media/may_2025_5.26969842.webp";